export default __webpack_public_path__ + "static/DMSans-Bold-6880ee4b239d2fd3144c5e1b7c707937.woff2";